import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { iconFromStatus, asFullLink } from '../util/selectors'
import { PASS_STATUS, PASS_STATUS_STYLE } from '../util/constants'
import { PassShape } from '../specs'
import CopyLinkSnackbar from '../components/copy-link-snackbar'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Checkbox from '@material-ui/core/Checkbox'
import Avatar from '@material-ui/core/Avatar'
import Icon from '@material-ui/core/Icon'
const styles = theme => ({
  item: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  [PASS_STATUS.CREATED]: {
    backgroundColor: theme.palette.secondary[PASS_STATUS_STYLE.CREATED],
    color: "#fff"
  },
  [PASS_STATUS.REGISTERED]: {
    backgroundColor: theme.palette.secondary[PASS_STATUS_STYLE.REGISTERED],
    color: "#fff"
  },
  [PASS_STATUS.REDEEMED]: {
    backgroundColor: theme.palette.secondary[PASS_STATUS_STYLE.REGISTERED],
    color: "#fff"
  }
});

export const PassListItem = (props) => {
  const classes = props.classes;
  const { status, link, guest_name, pass_id, pin } = props.pass;
  const isChecked = props.isChecked;
  const isCreated = status === PASS_STATUS.CREATED;
  const icon = iconFromStatus(status);
  function selectPass(_id) {
    return function (e) {
      return props.onChange(_id);
    }
  }
  return (
    <ListItem className={classes.item} >
      <Avatar className={classes[status]}>
        <Icon >
          {icon}
        </Icon>
      </Avatar>
      <ListItemText primary={guest_name} />
      {isCreated && link && pin ?
        <CopyLinkSnackbar isChecked={isChecked} textToCopy={asFullLink(link)} afterCopyMessage={`Copied! pin is ${pin}`} />
        : ""}
      <ListItemSecondaryAction>
        <Checkbox
          onChange={selectPass(pass_id)}
          checked={isChecked}
        />
      </ListItemSecondaryAction>
    </ListItem >
  );
}

PassListItem.propTypes = {
  pass: PassShape,
  isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.object
}

export default withStyles(styles)(PassListItem);


// WEBPACK FOOTER //
// ./src/components/pass-list-item.js